import { SettingsModule } from 'modules';

export const SettingsScreen = () => {
  return <SettingsModule />;
};
